<template>
  <div class="homes main-bg">
    <div class="home-banner-bg">
      <banner-gsap></banner-gsap>
    </div>
    <div class="home-container">
      <!-- banner -->
      <div class="home-banner-content">
        <p class="home-banner-title main-light-cl">{{ $t('homeTemplate.text_18') }}</p>
        <div class="home-banner-bottom">
          <div class="home-banner-notlogin main-light-bd" v-if="!isLogin">
            <input
              class="home-banner-input main-light-cl"
              :placeholder="$t('homeTemplate.text_21')"
              type="text"
              v-model="loginValue"
              @blur="regLoginInput">
            <c-button
              v-if="userSkin === '1'"
              class="home-banner-button"
              width="120px"
              height="46px"
              style="font-size: 16px;"
              defaultColorClass="main-light-bg blue-cl"
              hoverColorClass="blue-bg white-cl"
              activeColorClass="blue-bg white-cl"
              @click="registerLink('/register', {[loginType]: loginValue})"
              >
              {{ $t('homeTemplate.text_20') }}
            </c-button>
            <c-button
              v-else
              class="home-banner-button"
              width="120px"
              height="46px"
              style="font-size: 16px;"
              defaultColorClass="blue-bg white-cl"
              hoverColorClass="blue-60-bg white-cl"
              activeColorClass="blue-bg white-cl"
              @click="registerLink('/register', {[loginType]: loginValue})"
              >
              {{ $t('homeTemplate.text_20') }}
            </c-button>
            <p class="red-cl register-error" v-if="loginErrorFlg">{{ errorTexts }}</p>
          </div>
          <div class="home-banner-login" v-else>
            <c-button
              width="320px"
              height="48px"
              style="font-size: 16px;"
              @click="btnLink('/futures')">
              {{ $t('homeTemplate.text_19') }}
            </c-button>
          </div>
          <div
            class="home-banner-icons main-cl"
            v-for="(item, index) in homeChannelList"
            :key="index"
            @click="channelDownload(item.id)">
            <svg-icon :iconClass="`icon_${item.name.replace(/\s*/g, '')}`" className="icon-24"></svg-icon>
          </div>
          <!-- <div class="home-banner-icons main-cl" @click="downloadLink('ios')" >
            <svg-icon iconClass="apple" className="icon-24"></svg-icon>
          </div> -->
          <!-- <div class="home-banner-icons" @click="btnLink('/download')">
            <svg-icon iconClass="google" className="icon-24"></svg-icon>
          </div> -->
          <!-- <div class="home-banner-icons main-cl" @click="downloadLink('android')">
            <svg-icon iconClass="android" className="icon-24"></svg-icon>
          </div> -->
          <div class="home-banner-icons main-cl">
            <a-tooltip
              placement="bottom"
              :arrowPointAtCenter="true">
              <svg-icon iconClass="qrcode" className="icon-24" style="padding: 12px;"></svg-icon>
              <template slot="title">
                <div class="download-content">
                  <!-- <img class="download-code" src="@/assets/img/qrCode.png" /> -->
                  <c-download-qrcode></c-download-qrcode>
                  <p class="download-text">{{ $t("appDownLoad.headerCode") }}</p>
                </div>
              </template>
            </a-tooltip>
          </div>
        </div>
      </div>
      <!-- 公告 -->
      <div class="home-notices" v-if="noticeList.length">
        <div class="home-notice-content">
          <svg-icon iconClass="notice" className="icon-16 blue-cl mr-8"></svg-icon>
          <p class="home-notice-more blue-cl" @click="btnLink('/noticeInfo')">
            {{$t('home.more')}}
            <svg-icon iconClass="arrow-right" className="icon-14 ml-8"></svg-icon>
          </p>
        </div>
        <div class="home-notice-position">
          <a-carousel dotPosition="right" autoplay :dots="false">
            <div v-for="(parentItem, parentIndex) in noticeList" :key="parentIndex">
              <div v-for="(item, index) in parentItem" :key="index" style="float: left;">
                <span v-if="item && index !== 0" class="home-notice-interval gray-cl mr-16 ml-16">/</span>
                <span
                  class="home-notice-item gray-cl"
                  @click="btnLink(`/noticeInfo/${item.id}`)">
                    {{item.noticeText}}
                </span>
              </div>
            </div>
          </a-carousel>
        </div>
      </div>
      <!-- 广告banner位 -->
      <SwiperBanner :slideList="slideList" />
      <!-- 24小时行情 -->
      <Market :fromHome="true" />
      <!-- 核心产品 -->
      <Product />
      <!-- 新手引导 -->
      <Step />
      <!-- 产品与服务 -->
      <Service />
      <!-- 下载 -->
      <download from="homes"/>
    </div>
    <!-- 页底 Trand Now -->
    <div class="trade-now">
      <div class="trade-now-content">
        <p class="trade-now-title white-cl">{{ $t('homeTemplate.text_22') }}</p>
        <p class="trade-now-desc white-cl">{{ $t('homeTemplate.text_23') }}</p>
        <div class="trade-now-notlogin white-bd" v-if="!isLogin">
          <input class="trade-now-input white-cl"
            :placeholder="$t('homeTemplate.text_21')"
            type="text"
            v-model="registerValue"
            @blur="tradeLoginInput" />
          <c-button
            class="trade-now-button"
            width="120px"
            height="46px"
            defaultColorClass="white-bg blue-cl"
            hoverColorClass="white-bg blue-cl"
            activeColorClass="white-bg blue-cl"
            @click="registerLink('/register', {[loginType]: registerValue})"
            >
            {{ $t('homeTemplate.text_20') }}
          </c-button>
          <p class="red-cl register-error" v-if="registerErrorFlg">{{ errorTexts }}</p>
        </div>
        <div class="trade-now-login" v-else>
          <c-button
            width="320px"
            height="48px"
            style="font-size: 16px;"
            defaultColorClass="white-bg blue-cl"
            hoverColorClass="white-bg blue-cl"
            activeColorClass="white-bg blue-cl"
            @click="btnLink('/futures')">
            {{ $t('homeTemplate.text_19') }}
          </c-button>
        </div>
      </div>
      <div class="trade-now-bg">
        <div class="wave wave1"></div>
        <div class="wave wave2"></div>
        <div class="wave wave3"></div>
        <div class="wave wave4"></div>
      </div>
    </div>
    <!-- 客服/回到顶部 -->
    <div class="fixed-box">
      <!--<svg-icon iconClass="customer" className="icon-60 main-cl" @click="openZenDesk"></svg-icon>-->
      <svg-icon iconClass="customer" id="udesk" @click="initUDesk" className="icon-60 main-cl"></svg-icon>
      <div class="mt-40">
        <a-back-top>
          <svg-icon iconClass="backtop" className="icon-60 main-cl"></svg-icon>
        </a-back-top>
      </div>
    </div>
  </div>
</template>

<script>
import { imgMap, colorMap, getCookie } from '@/utils';
import download from '@/views/appDownload.vue';
import Market from '@/views/market/index.vue';
// import Recommend from '../recommend/china.vue';
// import Custom from '../custom/china.vue';
import Product from '../product/index.vue';
import Step from '../step/index.vue';
import Service from '../service/index.vue';
import SwiperBanner from '../swiper-banner/index.vue';
import BannerGsap from '../banner-gsap/index.vue';

export default {
  components: {
    // Recommend,
    // Custom,
    Market,
    Product,
    Step,
    Service,
    SwiperBanner,
    download,
    BannerGsap,
  },
  data() {
    return {
      krwCheck: false, // krw 弹窗下次不再提示
      krwBg: `background: url(${imgMap.krwhomebg})`,
      // 首页轮播图的 宽和高
      styles: {
        width: '100%',
        height: '580px',
        backgroundColor: colorMap['c-3-bg'],
      },
      stylesHeight: '580',
      // 首页 轮播图
      slideList: [],
      // 首页 轮播图-文案
      slideListTitle: {
        title: '',
        subTitle: '',
      },
      // 首页 公告数据
      noticeList: [],
      // class
      photoAppShow: false,
      productShow: false,
      homeEditReady: false,
      home_edit_html: '',
      moreButtonImg1: `background: url(${imgMap.ggicon})`,
      moreButtonImg2: `background: url(${imgMap.ggicon_h})`,
      moreButtonImg3: `background: url(${imgMap.om_gg})`,
      registerInfo: '',
      coHeaderSymbol: [],
      registerValue: '', // trade now登录value
      registerErrorFlg: false,
      isRegisterBtn: false,
      loginValue: '', // banner登录value
      isLoginBtn: true,
      loginErrorFlg: false,
      loginType: 'phone',
      // hasZeListener: false, // 是否已监听过zendesk未读消息推送
      homeChannelList: [], // 首页下载列表
    };
  },
  computed: {
    coinTagLangs() {
      return this.$store.state.baseData.coinTagLangs;
    },
    appDownload() {
      return this.$store.state.baseData.app_download;
    },
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 邮箱手机号校验
    regExps() { return this.$store.state.regExp; },
    errorTexts() {
      if (this.loginType === 'phone') {
        return this.$t('register.phoneError'); // 手机号输入格式不正确
      }
      return this.$t('register.emailError'); // 邮箱输入格式不正确
    },
    // 用户选择的skin
    userSkin() {
      return getCookie('cusSkin') || getCookie('defSkin');
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getLundata();
      this.getHomeChannelList();
    },

    goRegister() {
      if (this.registerInfo) {
        this.$router.push(`/register?email=${this.registerInfo}`);
      }
    },

    goPage(path) {
      this.$router.push(`/${path}`);
    },

    download(type) {
      window.open(this.appDownload[`${type}_download_url`]);
    },

    registerChange(val) {
      this.registerInfo = val;
    },

    getIconImg(val) {
      return `background:url(${imgMap[`home_edit_icon${val}`]})`;
    },

    // 公告更多跳转
    // btnLink() {
    //   this.$router.push('/noticeInfo');
    // },
    // 路由跳转
    btnLink(link, query) {
      if (link.indexOf('http') > -1) {
        window.location.href = link;
      } else {
        this.$router.push({ path: link, query });
      }
    },
    registerLink(link, query) {
      if (this.isLoginBtn) {
        this.$router.push({ path: link, query });
      }
    },

    onScrollHandle() {
      window.onscroll = () => {
        if (!this.productShow) {
          const WH = window.innerHeight;
          const photoAppTop = this.$refs.photoApp.getBoundingClientRect().y;
          const productTop = this.$refs.product.getBoundingClientRect().y;
          if (WH - photoAppTop > 300) {
            this.photoAppShow = true;
          }
          if (WH - productTop > 200) {
            this.productShow = true;
          }
        } else {
          window.onscroll = null;
        }
      };
    },
    // 获取 首页数据(公告、轮播图)
    getLundata() {
      const dataObj = {};
      if (this.$route.query && this.$route.query.preview && this.$route.query.homeBoard) {
        dataObj.preview = Number(this.$route.query.preview) > 1 ? 0
          : Number(this.$route.query.preview);
        dataObj.homeBoard = Number(this.$route.query.homeBoard);
      }
      this.axios({
        url: this.$store.state.url.common.index_data,
        headers: {},
        params: dataObj,
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          // 首页轮播图
          const { cmsAdvertList, noticeInfoList } = data.data;
          if (cmsAdvertList && cmsAdvertList.length) {
            this.slideList = data.data.cmsAdvertList;
          }
          this.slideListTitle.title = data.data.index_international_title1 || '';
          this.slideListTitle.subTitle = data.data.index_international_title2 || '';
          // 首页公告
          if (noticeInfoList && noticeInfoList.length) {
            const arr = [];
            noticeInfoList.forEach((item) => {
              // const space = item.title.length > length ? '...' : '';
              arr.push({
                // noticeText: `${item.title.substr(0, length)}${space}`,
                noticeText: item.title,
                id: item.id,
              });
            });
            this.noticeList = this.formatNoticeList(arr);
          }
          this.home_edit_html = data.data.footer_warm_prompt;
        }
        this.homeEditReady = true;
      });
    },

    formatNoticeList(arr) {
      const result = [];
      for (let i = 0; i < arr.length; i += 3) {
        result.push(arr.slice(i, i + 3));
      }
      return result;
    },

    regLoginInput() {
      this.isLoginBtn = false;
      this.loginErrorFlg = false;
      this.loginType = this.loginValue.indexOf('@') !== -1 ? 'email' : 'phone';
      if (this.loginValue === '') {
        this.isLoginBtn = true;
        return;
      }
      if (!this.regExps.email.test(this.loginValue) && !this.regExps.phone.test(this.loginValue)) {
        this.loginErrorFlg = true;
        return;
      }
      this.isLoginBtn = true;
    },

    tradeLoginInput() {
      this.isLoginBtn = false;
      this.registerErrorFlg = false;
      this.loginType = this.registerValue.indexOf('@') !== -1 ? 'email' : 'phone';
      if (this.registerValue === '') {
        this.isLoginBtn = true;
        return;
      }
      if (!this.regExps.email.test(this.registerValue) && !this.regExps.phone.test(this.registerValue)) {
        this.registerErrorFlg = true;
        return;
      }
      this.isLoginBtn = true;
    },

    // // 打开zendesk
    // openZenDesk() {
    //   window.zE('messenger', 'open');
    //   const map = {
    //     el_GR: 'el', en_US: 'en-US', ja_JP: 'ja', ko_KR: 'ko', zh_CN: 'zh-cn',
    //   };
    //   const locale = localStorage.getItem('locale') || 'en_US';
    //   window.zE('messenger:set', 'locale', map[locale]);
    //   this.addZeMessageListener();
    // },
    //
    // // 监听zendesk未读消息
    // addZeMessageListener() {
    //   if (window.zE && !this.hasZeListener) {
    //     this.hasZeListener = true;
    //     window.zE('messenger:on', 'unreadMessages', (count) => {
    //       console.log(`You have ${count} unread message(s).`);
    //     });
    //   }
    // },
    // banner 下载
    downloadLink(type) {
      window.open(this.appDownload[`${type}_download_url`]);
    },
    // 获取首页下载列表 
    getHomeChannelList() {
      this.axios({
        url: 'channel/type/list',
        method: 'get',
      }).then((res) => {
        if (!Number(res.code)) {
          if (res.data[0] && res.data[0].type === 'ios') {
            this.homeChannelList = res.data
          } else {
            this.homeChannelList = res.data.reverse()
          }
        } else {
          this.$bus.$emit('tip', {
            text: res.message,
            type: 'error',
          });
        }
      })
    },
    // 获取渠道下载地址
    channelDownload(id) {
      this.axios({
        url: 'channel/download?id='+id,
        method: 'get',
      }).then((res) => {
        if (!Number(res.code)) {
          window.open(res.data);
        } else {
          this.$bus.$emit('tip', {
            text: res.message,
            type: 'error',
          });
        }
      })
    },
  },
  beforeDestroy() {
    window.onscroll = null;
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';
.homes{
  position: relative;
  padding-top: 64px;
  .home-alert {
    .noclick {
      margin-left: 50%;
      margin-top: 20px;
      display: inline-block;
      transform: translate3d(-50%, 0, 0);
      .noclick-text {
        margin-left: 10px;
        font-size: 12px;
        cursor: pointer;
        user-select: none;
      }
    }
    .home-alert-all {
      position: fixed;
      width: 100%;
      height: 100%;
      // 1000的原因是 首页有999
      z-index: 1000;
      top: 0;
      left: 0;
    }
    .alert-button {
      margin-left: 50%;
      transform: translate3d(-50%, 0, 0);
    }
    .home-alert-body-warning {
      margin-top: 10px;
      font-size: 12px;
    }
    .home-alert-body-text {
      font-size: 14px;
      line-height: 22px;
    }
    .home-alert-body-title {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 10px;
    }
    .home-alert-body {
      padding: 30px;
    }
    .home-alert-content {
      width: 600px;
      min-height: 580px;
      position: fixed;
      left: 50%;
      top: 50%;
      z-index: 1001;
      transform: translate3d(-50%, -50%, 0);
    }
    .home-alert-bg {
      height: 214px;
      width: 100%;
    }
    .home-alert-title {
      padding-left: 30px;
      padding-top: 20px;
      font-size: 16px;
    }
    .alert-close {
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer
    }
  }
  // .home-bg {
  //   padding-top: 520px;
  // }
  // .swipers {
  //   position: absolute;
  //   width: 100%;
  //   top: -60px;
  // }
  // 公告样式
  .bulletinBoard{
    width: 100%;
    height: 40px;
    position: absolute;
    left:0;
    top:0;
    z-index: 5;
    text-align: center;
    .backgrounds{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .bull-bar {
      .notice-item {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        text-align: center;
        position: relative;
        display: inline-block;
        padding-left: 20px;
        box-sizing: border-box;
        line-height: 40px;
        height: 40px;
        .hoverShow {
          display: none;
        }
        .hoverHide {
          display: inline-block;
        }
        i{
          margin-left: 20px;
          display: inline-block;
        }
        &:last-child {
          i{
            display: none;
          }
        }
        &:hover {
          .hoverShow {
            display: inline-block;
          }
          .hoverHide {
            display: none;
          }
        }
      }
    }
    .more{
      position: absolute;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      text-align: right;
      right: 20px;
      top: 7px;
    }
  }
  // banner背景
  .home-banner-bg {
    height: 464px;
    width: 70%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
  .home-container {
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Medium';
    // banner
    .home-banner-content {
      padding-top: 116px;
      height: 464px;
      box-sizing: border-box;
      z-index: 2;
      position: relative;
      width: 55%;
      .home-banner-title {
        font-size: 50px;
        line-height: 80px;
        max-width: 650px;
        margin-bottom: 40px;
        font-weight: 600;
      }
      .home-banner-bottom {
        display: flex;
        align-items: center;
      }
      .home-banner-notlogin {
        width: 445px;
        height: 46px;
        border-width: 1px;
        border-style: solid;
        border-radius: 4px;
        // overflow: hidden;
        margin-right: 24px;
        position: relative;
        .home-banner-input {
          font-size: 16px;
          line-height: 26px;
          padding: 11px 24px;
          box-sizing: border-box;
          float: left;
          width: 325px;
          &::placeholder {
            color: $white;
          }
        }
        .home-banner-button {
          float: right;
          border-radius: 0;
        }
      }
      .home-banner-login {
        margin-right: 24px;
      }
      .home-banner-icons {
        width: 48px;
        height: 48px;
        border-radius: 4px;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        cursor: pointer;
        background-color: $light-ft;
        &:hover {
          background-color: $blue;
        }
      }
    }
    // notice
    .home-notices {
      position: relative;
      .home-notice-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 21px 0;
      }
      .home-notice-position {
        width: 1120px;
        position: absolute;
        left: 24px;
        top: 21px;
      }
      .home-notice-item, .home-notice-more, .home-notice-interval {
        font-size: 14px;
        line-height: 22px;
        cursor: pointer;
      }
      .home-notice-item {
        max-width: 340px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        &:hover {
          color: $blue !important;
        }
      }
      .home-notice-interval {
        float: left;
      }
    }
  }
  .ml-8 {
    margin-left: 8px;
  }
  .mr-8 {
    margin-right: 8px;
  }
  .mr-16 {
    margin-right: 16px;
  }
  .ml-16 {
    margin-left: 16px;
  }
}
.download-content {
  padding: 15px 15px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Medium';
  .download-code {
    width: 140px;
    height: 140px;
  }
  .download-text {
    font-size: 14px;
    line-height: 22px;
    margin-top: 8px;
  }
}
.trade-now {
  width: 100%;
  height: 284px;
  position: relative;
  margin-top: 100px;
  .trade-now-bg {
    width: 100%;
    height: 284px;
    position: absolute;
    z-index: 8;
    bottom: 0;
    left: 0;
    background: rgb(23, 82, 252);
    overflow: hidden;
    .wave {
      width: 100%;
      height: 100px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: url('~@/assets/img/wave.png');
      background-size: 1000px 100px;
    }
    .wave.wave1 {
      animation: animate1 16s linear infinite;
      z-index: 10;
      opacity: 0.3;
      animation-delay: 0s;
      bottom: 0;
    }
    .wave.wave2 {
      animation: animate2 13s linear infinite;
      z-index: 9;
      opacity: 0.13;
      animation-delay: -6s;
      bottom: 0;
    }
    .wave.wave3 {
      animation: animate1 7s linear infinite;
      z-index: 8;
      opacity: 0.2;
      animation-delay: -7s;
      bottom: 0;
    }

    .wave.wave4 {
      animation: animate2 5s linear infinite;
      z-index: 7;
      opacity: 0.21;
      animation-delay: -5s;
      bottom: 0;
    }
    @keyframes animate1 {
      0% {
        background-position-x: 0;
      }
      100% {
        background-position-x: 1000px;
      }
    }
    @keyframes animate2 {
      0% {
        background-position-x: 0;
      }
      100% {
        background-position-x: -1000px;
      }
    }
  }
  .trade-now-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // zindex小一点 不要盖住header
    z-index: 9;
    position: relative;
    .trade-now-title {
      font-size: 36px;
      line-height: 58px;
      margin-bottom: 8px;
      font-family: 'Medium';
      font-weight: 600;
    }
    .trade-now-desc {
      font-size: 16px;
      line-height: 26px;
      margin-bottom: 24px;
    }
    .trade-now-notlogin {
      width: 445px;
      height: 46px;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      // overflow: hidden;
      margin-right: 24px;
      position: relative;
      .trade-now-input {
        font-size: 16px;
        line-height: 26px;
        padding: 11px 24px;
        box-sizing: border-box;
        float: left;
        width: 325px;
        &::placeholder {
          color: $white;
        }
      }
      .trade-now-button {
        float: right;
        font-family: 'Medium';
        font-size: 16px;
        font-weight: 600;
        border-radius: 0;
      }
    }
    .trade-now-login {
      margin-right: 24px;
    }
  }
}
.register-error {
  font-size: 12px;
  line-height: 24px;
  position: absolute;
  left: 0;
  bottom: -24px;
}
.fixed-box {
  position: fixed;
  right: 96px;
  bottom: 50px;
  z-index: 20;
  height: 124px;
  .icon-60 {
    font-size: 44px;
    display: block;
    cursor: pointer;
  }
  .mt-40 {
    margin-top: 40px;
  }
}
.light {
  .home-banner-icons {
    background-color: $white !important;
    &:hover {
      background-color: $blue !important;
      color: $white !important;
    }
  }
  .home-banner-input::placeholder {
    color: $blue !important;
  }
}
</style>
